export default __webpack_public_path__ + "static/media/nftRight.e1b9710b.png";